import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoaderService } from '../_services/loader.service';
import { MyPropertyService } from 'src/services/my-property';

@Component({
    selector: 'app-my-properties-listing',
    templateUrl: './my-properties-listing.component.html',
    styleUrls: ['./my-properties-listing.component.css'],
    standalone: false
})
export class MyPropertiesListingComponent implements OnInit {

  constructor(private myPropertyService: MyPropertyService, private loader: LoaderService) { }

  @Input() ActiveCollection = { count: 0, data: [] };
  @Input() PendingCollection = { count: 0, data: [] };
  @Input() RejectedCollection = { count: 0, data: [] };
  @Input() SoldCollection = { count: 0, data: [] };
  @Input() activeProcessed = false;
  @Input() pendingProcessed = false;
  @Input() rejectedProcessed = false;
  @Input() soldProcessed = false;
  @Input() IsLoading = true;
  // tslint:disable-next-line: no-output-rename
  @Output('getActiveProperty') getActiveProperty: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line: no-output-rename
  @Output('getPendingProperty') getPendingProperty: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line: no-output-rename
  @Output('getRejectedProperty') getRejectedProperty: EventEmitter<any> = new EventEmitter();

  // tslint:disable-next-line: no-output-rename
  @Output('getSoldProperty') getSoldProperty: EventEmitter<any> = new EventEmitter();
  ngOnInit(): void {
  }
  DeleteEvent(obj: any, refreshTab: string) {
    this.IsLoading = true;
    this.myPropertyService.Delete(obj.PropertyId).subscribe(() => {
      if (refreshTab === 'active') {
        this.getActiveProperty.emit();
      } else if (refreshTab === 'pending') {
        this.getPendingProperty.emit();

      } else if (refreshTab === 'rejected') {
        this.getRejectedProperty.emit();
      }
      this.IsLoading = false;
    });
  }

  markSoldProperty(obj: any) {
    debugger;
    this.myPropertyService.markSoldProperty(obj.PropertyId).subscribe((data) => {
      this.getActiveProperty.emit();
    });
  }

  getActivePropertyMethod() {
    this.getActiveProperty.emit();
  }
  getPendingPropertyMethod() {
    this.getPendingProperty.emit();
  }

  getRejectedPropertyMethod() {
    this.getRejectedProperty.emit();
  }

  getSoldPropertyMethod() {
    this.getSoldProperty.emit();
  }
}
